<ng-template #modal>
  <div class="modal-container">
    <span class="close-btn icon-close" (click)="close()"></span>
    <div class="display-area">
      <ng-container [ngSwitch]="modalEvent.icon">
        <span
          *ngSwitchCase="ModalIconType.WARNING"
          class="icon icon-error"
        ></span>
        <span
          *ngSwitchCase="ModalIconType.LEAVE"
          class="icon icon-logout"
        ></span>
        <span
          *ngSwitchCase="ModalIconType.SUCCESS"
          class="icon icon-check"
        ></span>
      </ng-container>

      <span *ngIf="modalEvent.title" class="title">
        {{ modalEvent.title | translate: modalEvent.data }}
      </span>
      <p *ngFor="let item of modalEvent.content" class="content">
        {{ item | translate: modalEvent.data }}
      </p>
      <lynx-button
        id="btn-{{ modalEvent.button.id }}"
        *ngIf="modalEvent.button"
        (clickAction)="closeWithAction()"
        [text]="modalEvent.button.text"
      ></lynx-button>
    </div>
  </div>
</ng-template>
